import { useEffect } from 'react';
import { stopAllSounds } from '../utils/playSound';

export const useBrowserLeaveActions = ({
  reloadOnReturn = true,
  onLeaveCallback,
  onReturnCallback,
}: {
  reloadOnReturn?: boolean;
  onLeaveCallback?: () => void;
  onReturnCallback?: () => void;
}) => {
  // on browser leave, we stop sounds and game, on come back we reload the page
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (reloadOnReturn) {
          window.location.reload();
        } else {
          onReturnCallback?.();
        }
      }
      if (document.visibilityState === 'hidden') {
        // stop sounds and game if we are reloading on resume (default)
        if (reloadOnReturn) {
          stopAllSounds();
        }
        onLeaveCallback?.();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // security
    if (onReturnCallback && reloadOnReturn) {
      throw new Error(
        'onReturnCallback and reloadOnReturn should not be both set'
      );
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onLeaveCallback]);

  // DO WE BLOCK USER FROM LEAVING THE PAGE?
  // useEffect(() => {
  //   window.addEventListener('beforeunload', (e) => {
  //     e.preventDefault();
  //     window.location.reload();
  //   });

  //   return () => {
  //     window.removeEventListener('beforeunload', (e) => {
  //       e.preventDefault();
  //       window.location.reload();
  //     });
  //   };
  // }, []);
};
